import { VyIcon } from "@vy/ui-design-system";
import { isObject, isString } from "lodash";
import { type HTMLAttributes, type ReactNode } from "react";
import { type ProductOption } from "../fixed-charges-edit-table-types/product-option-type";
import { ListItemIcon, Typography } from "@mui/material"; 
import { isAddProduct } from "../fixed-charges-edit-table-utils";

export const renderOption = (props: HTMLAttributes<HTMLLIElement>, option: ProductOption): ReactNode => {
    if (isObject(option) && isAddProduct(option)) {

      return (
        <li {...props} style={{ borderTop: '1px solid #e0e0e0', marginTop: '8px', paddingTop: '8px' }}>
          <ListItemIcon sx={{ minWidth: '24px' }}>
            <VyIcon icon="PlusMedium" style={{ transform: 'scale(0.8)', color: 'rgba(13, 27, 39, 0.87)' }} />
          </ListItemIcon>
          <Typography
            sx={{
              color: "rgba(13, 27, 39, 0.87)",
              fontWeight: 500
            }}>
            {option.label}
          </Typography>
        </li>
      );
    }

    return <li {...props}>{isString(option) ? option : option.label}</li>;
  };